function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
export var StatsType;
(function(StatsType) {
    StatsType["Codec"] = "codec";
    StatsType["InboundRTP"] = "inbound-rtp";
    StatsType["OutboundRTP"] = "outbound-rtp";
    StatsType["RemoteInboundRTP"] = "remote-inbound-rtp";
    StatsType["RemoteOutboundRTP"] = "remote-outbound-rtp";
    StatsType["MediaSource"] = "media-source";
    StatsType["CSRC"] = "csrc";
    StatsType["PeerConnection"] = "peer-connection";
    StatsType["DataChannel"] = "data-channel";
    StatsType["Stream"] = "stream";
    StatsType["Track"] = "track";
    StatsType["Transceiver"] = "transceiver";
    StatsType["Sender"] = "sender";
    StatsType["Receiver"] = "receiver";
    StatsType["Transport"] = "transport";
    StatsType["SCTPTransport"] = "sctp-transport";
    StatsType["CandidatePair"] = "candidate-pair";
    StatsType["LocalCandidate"] = "local-candidate";
    StatsType["RemoteCandidate"] = "remote-candidate";
    StatsType["Certificate"] = "certificate";
    StatsType["IceServer"] = "ice-server";
})(StatsType || (StatsType = {}));
export var RTCDtlsTransportState;
(function(RTCDtlsTransportState) {
    RTCDtlsTransportState["RTCDtlsTransportStateNew"] = "new";
    RTCDtlsTransportState["RTCDtlsTransportStateConnection"] = "connecting";
    RTCDtlsTransportState["RTCDtlsTransportStateConnected"] = "connected";
    RTCDtlsTransportState["RTCDtlsTransportStateClosed"] = "closed";
    RTCDtlsTransportState["RTCDtlsTransportStateFailed"] = "failed";
})(RTCDtlsTransportState || (RTCDtlsTransportState = {}));
var TimestampedData = function TimestampedData(data) {
    "use strict";
    _classCallCheck(this, TimestampedData);
    this.timestamp = data.timestamp / 1000;
};
var TimestampSeries = function TimestampSeries() {
    "use strict";
    _classCallCheck(this, TimestampSeries);
    this.timestamps = [];
};
export var WebRTCTransportData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCTransportData, TimestampedData);
    var _super = _createSuper(WebRTCTransportData);
    function WebRTCTransportData(stats) {
        _classCallCheck(this, WebRTCTransportData);
        var _this;
        _this = _super.call(this, stats);
        _this.packetsSent = stats.packetsSent;
        _this.packetsReceived = stats.packetsReceived;
        _this.bytesSent = stats.bytesSent;
        _this.bytesReceived = stats.bytesReceived;
        _this.selectedCandidatePairChanges = stats.selectedCandidatePairChanges;
        return _this;
    }
    return WebRTCTransportData;
}(TimestampedData);
export var WebRTCTransportSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCTransportSeries, TimestampSeries);
    var _super = _createSuper(WebRTCTransportSeries);
    function WebRTCTransportSeries() {
        _classCallCheck(this, WebRTCTransportSeries);
        var _this;
        _this = _super.call(this);
        _this.packetsSent = [];
        _this.packetsReceived = [];
        _this.bytesSent = [];
        _this.bytesReceived = [];
        _this.selectedCandidatePairChanges = [];
        return _this;
    }
    var _proto = WebRTCTransportSeries.prototype;
    _proto.push = function push(transportData) {
        this.timestamps.push(transportData.timestamp);
        this.packetsSent.push(transportData.packetsSent);
        this.packetsReceived.push(transportData.packetsReceived);
        this.bytesSent.push(transportData.bytesSent);
        this.bytesReceived.push(transportData.bytesReceived);
        this.selectedCandidatePairChanges.push(transportData.selectedCandidatePairChanges);
    };
    return WebRTCTransportSeries;
}(TimestampSeries);
export var WebRTCOutboundAudioRtpStreamData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCOutboundAudioRtpStreamData, TimestampedData);
    var _super = _createSuper(WebRTCOutboundAudioRtpStreamData);
    function WebRTCOutboundAudioRtpStreamData(stats) {
        _classCallCheck(this, WebRTCOutboundAudioRtpStreamData);
        var _this;
        _this = _super.call(this, stats);
        _this.packetsSent = stats.packetsSent;
        _this.bytesSent = stats.bytesSent;
        _this.retransmittedBytesSent = stats.retransmittedBytesSent;
        _this.retransmittedPacketsSent = stats.retransmittedPacketsSent;
        _this.headerBytesSent = stats.headerBytesSent;
        return _this;
    }
    return WebRTCOutboundAudioRtpStreamData;
}(TimestampedData);
export var WebRTCInboundAudioRtpStreamData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCInboundAudioRtpStreamData, TimestampedData);
    var _super = _createSuper(WebRTCInboundAudioRtpStreamData);
    function WebRTCInboundAudioRtpStreamData(stats) {
        _classCallCheck(this, WebRTCInboundAudioRtpStreamData);
        var _this;
        _this = _super.call(this, stats);
        _this.packetsReceived = stats.packetsReceived;
        _this.packetsLost = stats.packetsLost;
        _this.bytesReceived = stats.bytesReceived;
        _this.audioLevel = stats.audioLevel;
        _this.headerBytesReceived = stats.headerBytesReceived;
        _this.concealedSamples = stats.concealedSamples;
        _this.concealmentEvents = stats.concealmentEvents;
        _this.fecPacketsDiscarded = stats.fecPacketsDiscarded;
        _this.fecPacketsReceived = stats.fecPacketsReceived;
        _this.insertedSamplesForDeceleration = stats.insertedSamplesForDeceleration;
        _this.jitterBufferDelay = stats.jitterBufferDelay;
        _this.jitterBufferEmittedCount = stats.jitterBufferEmittedCount;
        _this.removedSamplesForAcceleration = stats.removedSamplesForAcceleration;
        _this.silentConcealedSamples = stats.silentConcealedSamples;
        _this.totalAudioEnergy = stats.totalAudioEnergy;
        _this.totalSamplesDuration = stats.totalSamplesDuration;
        _this.totalSamplesReceived = stats.totalSamplesReceived;
        return _this;
    }
    return WebRTCInboundAudioRtpStreamData;
}(TimestampedData);
export var WebRTCOutboundVideoRtpStreamData = /*#__PURE__*/ function(WebRTCOutboundAudioRtpStreamData) {
    "use strict";
    _inherits(WebRTCOutboundVideoRtpStreamData, WebRTCOutboundAudioRtpStreamData);
    var _super = _createSuper(WebRTCOutboundVideoRtpStreamData);
    function WebRTCOutboundVideoRtpStreamData(stats) {
        _classCallCheck(this, WebRTCOutboundVideoRtpStreamData);
        var _this;
        _this = _super.call(this, stats);
        _this.packetsSent = stats.packetsSent;
        _this.bytesSent = stats.bytesSent;
        _this.firCount = stats.firCount;
        _this.pliCount = stats.pliCount;
        _this.nackCount = stats.nackCount;
        _this.qpSum = stats.qpSum;
        _this.retransmittedBytesSent = stats.retransmittedBytesSent;
        _this.retransmittedPacketsSent = stats.retransmittedPacketsSent;
        _this.headerBytesSent = stats.headerBytesSent;
        _this.framesEncoded = stats.framesEncoded;
        _this.keyFramesEncoded = stats.keyFramesEncoded;
        _this.frameWidth = stats.frameWidth;
        _this.frameHeight = stats.frameHeight;
        _this.frameBitDepth = stats.frameBitDepth;
        _this.framesPerSecond = stats.framesPerSecond;
        _this.framesSent = stats.framesSent;
        _this.hugeFramesSent = stats.hugeFramesSent;
        _this.totalPacketSendDelay = stats.totalPacketSendDelay;
        _this.totalEncodeTime = stats.totalEncodeTime;
        _this.totalEncodedBytesTarget = stats.totalEncodedBytesTarget;
        _this.qualityLimitationResolutionChanges = stats.qualityLimitationResolutionChanges;
        return _this;
    }
    return WebRTCOutboundVideoRtpStreamData;
}(WebRTCOutboundAudioRtpStreamData);
export var WebRTCInboundVideoRtpStreamData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCInboundVideoRtpStreamData, TimestampedData);
    var _super = _createSuper(WebRTCInboundVideoRtpStreamData);
    function WebRTCInboundVideoRtpStreamData(stats) {
        _classCallCheck(this, WebRTCInboundVideoRtpStreamData);
        var _this;
        _this = _super.call(this, stats);
        _this.packetsReceived = stats.packetsReceived;
        _this.packetsLost = stats.packetsLost;
        _this.bytesReceived = stats.bytesReceived;
        _this.firCount = stats.firCount;
        _this.framesPerSecond = stats.framesPerSecond;
        _this.framesReceived = stats.framesReceived;
        _this.headerBytesReceived = stats.headerBytesReceived;
        _this.keyFramesDecoded = stats.keyFramesDecoded;
        _this.framesDecoded = stats.framesDecoded;
        _this.nackCount = stats.nackCount;
        _this.pliCount = stats.pliCount;
        _this.totalDecodeTime = stats.totalDecodeTime;
        _this.totalInterFrameDelay = stats.totalInterFrameDelay;
        _this.totalSquaredInterFrameDelay = stats.totalSquaredInterFrameDelay;
        return _this;
    }
    return WebRTCInboundVideoRtpStreamData;
}(TimestampedData);
export var WebRTCOutboundAudioRtpStreamSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCOutboundAudioRtpStreamSeries, TimestampSeries);
    var _super = _createSuper(WebRTCOutboundAudioRtpStreamSeries);
    function WebRTCOutboundAudioRtpStreamSeries() {
        _classCallCheck(this, WebRTCOutboundAudioRtpStreamSeries);
        var _this;
        _this = _super.call(this);
        _this.packetsSent = [];
        _this.bytesSent = [];
        _this.retransmittedBytesSent = [];
        _this.retransmittedPacketsSent = [];
        _this.headerBytesSent = [];
        return _this;
    }
    var _proto = WebRTCOutboundAudioRtpStreamSeries.prototype;
    _proto.push = function push(outboundData) {
        this.timestamps.push(outboundData.timestamp);
        this.packetsSent.push(outboundData.packetsSent);
        this.bytesSent.push(outboundData.bytesSent);
        this.retransmittedBytesSent.push(outboundData.retransmittedBytesSent);
        this.retransmittedPacketsSent.push(outboundData.retransmittedPacketsSent);
        this.headerBytesSent.push(outboundData.headerBytesSent);
    };
    return WebRTCOutboundAudioRtpStreamSeries;
}(TimestampSeries);
export var WebRTCInboundAudioRtpStreamSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCInboundAudioRtpStreamSeries, TimestampSeries);
    var _super = _createSuper(WebRTCInboundAudioRtpStreamSeries);
    function WebRTCInboundAudioRtpStreamSeries() {
        _classCallCheck(this, WebRTCInboundAudioRtpStreamSeries);
        var _this;
        _this = _super.call(this);
        _this.packetsReceived = [];
        _this.packetsLost = [];
        _this.bytesReceived = [];
        _this.audioLevel = [];
        _this.headerBytesReceived = [];
        _this.concealedSamples = [];
        _this.concealmentEvents = [];
        _this.fecPacketsDiscarded = [];
        _this.fecPacketsReceived = [];
        _this.insertedSamplesForDeceleration = [];
        _this.jitterBufferDelay = [];
        _this.jitterBufferEmittedCount = [];
        _this.removedSamplesForAcceleration = [];
        _this.silentConcealedSamples = [];
        _this.totalAudioEnergy = [];
        _this.totalSamplesDuration = [];
        _this.totalSamplesReceived = [];
        return _this;
    }
    var _proto = WebRTCInboundAudioRtpStreamSeries.prototype;
    _proto.push = function push(inboundData) {
        this.timestamps.push(inboundData.timestamp);
        this.packetsReceived.push(inboundData.packetsReceived);
        this.packetsLost.push(inboundData.packetsLost);
        this.bytesReceived.push(inboundData.bytesReceived);
        this.audioLevel.push(inboundData.audioLevel);
        this.headerBytesReceived.push(inboundData.headerBytesReceived);
        this.concealedSamples.push(inboundData.concealedSamples);
        this.concealmentEvents.push(inboundData.concealmentEvents);
        this.fecPacketsDiscarded.push(inboundData.fecPacketsDiscarded);
        this.fecPacketsReceived.push(inboundData.fecPacketsReceived);
        this.insertedSamplesForDeceleration.push(inboundData.insertedSamplesForDeceleration);
        this.jitterBufferDelay.push(inboundData.jitterBufferDelay);
        this.jitterBufferEmittedCount.push(inboundData.jitterBufferEmittedCount);
        this.removedSamplesForAcceleration.push(inboundData.removedSamplesForAcceleration);
        this.silentConcealedSamples.push(inboundData.silentConcealedSamples);
        this.totalAudioEnergy.push(inboundData.totalAudioEnergy);
        this.totalSamplesDuration.push(inboundData.totalSamplesDuration);
        this.totalSamplesReceived.push(inboundData.totalSamplesReceived);
    };
    return WebRTCInboundAudioRtpStreamSeries;
}(TimestampSeries);
export var WebRTCOutboundVideoRtpStreamSeries = /*#__PURE__*/ function(WebRTCOutboundAudioRtpStreamSeries) {
    "use strict";
    _inherits(WebRTCOutboundVideoRtpStreamSeries, WebRTCOutboundAudioRtpStreamSeries);
    var _super = _createSuper(WebRTCOutboundVideoRtpStreamSeries);
    function WebRTCOutboundVideoRtpStreamSeries() {
        _classCallCheck(this, WebRTCOutboundVideoRtpStreamSeries);
        var _this;
        _this = _super.call(this);
        _this.firCount = [];
        _this.pliCount = [];
        _this.nackCount = [];
        _this.qpSum = [];
        _this.framesEncoded = [];
        _this.keyFramesEncoded = [];
        _this.frameWidth = [];
        _this.frameHeight = [];
        _this.frameBitDepth = [];
        _this.framesPerSecond = [];
        _this.framesSent = [];
        _this.hugeFramesSent = [];
        _this.totalPacketSendDelay = [];
        _this.totalEncodeTime = [];
        _this.totalEncodedBytesTarget = [];
        _this.qualityLimitationResolutionChanges = [];
        return _this;
    }
    var _proto = WebRTCOutboundVideoRtpStreamSeries.prototype;
    _proto.push = function push(outboundData) {
        _get(_getPrototypeOf(WebRTCOutboundVideoRtpStreamSeries.prototype), "push", this).call(this, outboundData);
        this.firCount.push(outboundData.firCount);
        this.pliCount.push(outboundData.pliCount);
        this.nackCount.push(outboundData.nackCount);
        this.qpSum.push(outboundData.qpSum);
        this.framesEncoded.push(outboundData.framesEncoded);
        this.keyFramesEncoded.push(outboundData.keyFramesEncoded);
        this.frameWidth.push(outboundData.frameWidth);
        this.frameHeight.push(outboundData.frameHeight);
        this.frameBitDepth.push(outboundData.frameBitDepth ? outboundData.frameBitDepth : 0);
        this.framesPerSecond.push(outboundData.framesPerSecond);
        this.framesSent.push(outboundData.framesSent);
        this.hugeFramesSent.push(outboundData.hugeFramesSent);
        this.totalPacketSendDelay.push(outboundData.totalPacketSendDelay);
        this.totalEncodeTime.push(outboundData.totalEncodeTime);
        this.totalEncodedBytesTarget.push(outboundData.totalEncodedBytesTarget);
        this.qualityLimitationResolutionChanges.push(outboundData.qualityLimitationResolutionChanges);
    };
    return WebRTCOutboundVideoRtpStreamSeries;
}(WebRTCOutboundAudioRtpStreamSeries);
export var WebRTCInboundVideoRtpStreamSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCInboundVideoRtpStreamSeries, TimestampSeries);
    var _super = _createSuper(WebRTCInboundVideoRtpStreamSeries);
    function WebRTCInboundVideoRtpStreamSeries() {
        _classCallCheck(this, WebRTCInboundVideoRtpStreamSeries);
        var _this;
        _this = _super.call(this);
        _this.packetsReceived = [];
        _this.packetsLost = [];
        _this.bytesReceived = [];
        _this.firCount = [];
        _this.frameHeight = [];
        _this.frameWidth = [];
        _this.framesDecoded = [];
        _this.framesDropped = [];
        _this.framesPerSecond = [];
        _this.framesReceived = [];
        _this.headerBytesReceived = [];
        _this.keyFramesDecoded = [];
        _this.nackCount = [];
        _this.pliCount = [];
        _this.totalDecodeTime = [];
        _this.totalInterFrameDelay = [];
        _this.totalSquaredInterFrameDelay = [];
        return _this;
    }
    var _proto = WebRTCInboundVideoRtpStreamSeries.prototype;
    _proto.push = function push(inboundData) {
        this.timestamps.push(inboundData.timestamp);
        this.packetsReceived.push(inboundData.packetsReceived);
        this.packetsLost.push(inboundData.packetsLost);
        this.bytesReceived.push(inboundData.bytesReceived);
        this.firCount.push(inboundData.firCount);
        this.framesPerSecond.push(inboundData.framesPerSecond);
        this.framesReceived.push(inboundData.framesReceived);
        this.headerBytesReceived.push(inboundData.headerBytesReceived);
        this.framesDecoded.push(inboundData.framesDecoded);
        this.keyFramesDecoded.push(inboundData.keyFramesDecoded);
        this.nackCount.push(inboundData.nackCount);
        this.pliCount.push(inboundData.pliCount);
        this.totalDecodeTime.push(inboundData.totalDecodeTime);
        this.totalInterFrameDelay.push(inboundData.totalInterFrameDelay);
        this.totalSquaredInterFrameDelay.push(inboundData.totalSquaredInterFrameDelay);
    };
    return WebRTCInboundVideoRtpStreamSeries;
}(TimestampSeries);
export var WebRTCMediaStreamTrackData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCMediaStreamTrackData, TimestampedData);
    var _super = _createSuper(WebRTCMediaStreamTrackData);
    function WebRTCMediaStreamTrackData(stats) {
        _classCallCheck(this, WebRTCMediaStreamTrackData);
        var _this;
        _this = _super.call(this, stats);
        _this.frameWidth = stats.frameWidth;
        _this.frameHeight = stats.frameHeight;
        _this.framesSent = stats.framesSent;
        _this.hugeFramesSent = stats.hugeFramesSent;
        return _this;
    }
    return WebRTCMediaStreamTrackData;
}(TimestampedData);
export var WebRTCMediaStreamTrackSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCMediaStreamTrackSeries, TimestampSeries);
    var _super = _createSuper(WebRTCMediaStreamTrackSeries);
    function WebRTCMediaStreamTrackSeries() {
        _classCallCheck(this, WebRTCMediaStreamTrackSeries);
        var _this;
        _this = _super.call(this);
        _this.frameWidth = [];
        _this.frameHeight = [];
        _this.framesSent = [];
        _this.hugeFramesSent = [];
        return _this;
    }
    var _proto = WebRTCMediaStreamTrackSeries.prototype;
    _proto.push = function push(trackData) {
        this.timestamps.push(trackData.timestamp);
        this.frameWidth.push(trackData.frameWidth ? trackData.frameWidth : 0);
        this.frameHeight.push(trackData.frameHeight ? trackData.frameHeight : 0);
        this.framesSent.push(trackData.framesSent ? trackData.framesSent : 0);
        this.hugeFramesSent.push(trackData.hugeFramesSent ? trackData.hugeFramesSent : 0);
    };
    return WebRTCMediaStreamTrackSeries;
}(TimestampSeries);
export var WebRTCInboundAudioStreamTrackData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCInboundAudioStreamTrackData, TimestampedData);
    var _super = _createSuper(WebRTCInboundAudioStreamTrackData);
    function WebRTCInboundAudioStreamTrackData(stats) {
        _classCallCheck(this, WebRTCInboundAudioStreamTrackData);
        var _this;
        _this = _super.call(this, stats);
        _this.jitterBufferDelay = stats.jitterBufferDelay;
        _this.jitterBufferEmittedCount = stats.jitterBufferEmittedCount;
        _this.audioLevel = stats.audioLevel;
        _this.concealedSamples = stats.concealedSamples;
        _this.concealmentEvents = stats.concealmentEvents;
        _this.insertedSamplesForDeceleration = stats.insertedSamplesForDeceleration;
        _this.removedSamplesForAcceleration = stats.removedSamplesForAcceleration;
        _this.silentConcealedSamples = stats.silentConcealedSamples;
        _this.totalAudioEnergy = stats.totalAudioEnergy;
        _this.totalSamplesDuration = stats.totalSamplesDuration;
        _this.totalSamplesReceived = stats.totalSamplesReceived;
        _this.jitterBufferFlushes = stats.jitterBufferFlushes;
        return _this;
    }
    return WebRTCInboundAudioStreamTrackData;
}(TimestampedData);
export var WebRTCInboundAudioStreamTrackSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCInboundAudioStreamTrackSeries, TimestampSeries);
    var _super = _createSuper(WebRTCInboundAudioStreamTrackSeries);
    function WebRTCInboundAudioStreamTrackSeries() {
        _classCallCheck(this, WebRTCInboundAudioStreamTrackSeries);
        var _this;
        _this = _super.call(this);
        _this.jitterBufferDelay = [];
        _this.jitterBufferEmittedCount = [];
        _this.audioLevel = [];
        _this.concealedSamples = [];
        _this.concealmentEvents = [];
        _this.insertedSamplesForDeceleration = [];
        _this.removedSamplesForAcceleration = [];
        _this.silentConcealedSamples = [];
        _this.totalAudioEnergy = [];
        _this.totalSamplesDuration = [];
        _this.totalSamplesReceived = [];
        _this.jitterBufferFlushes = [];
        return _this;
    }
    var _proto = WebRTCInboundAudioStreamTrackSeries.prototype;
    _proto.push = function push(trackData) {
        this.timestamps.push(trackData.timestamp);
        this.jitterBufferDelay.push(trackData.jitterBufferDelay);
        this.jitterBufferEmittedCount.push(trackData.jitterBufferEmittedCount);
        this.audioLevel.push(trackData.audioLevel);
        this.concealedSamples.push(trackData.concealedSamples);
        this.concealmentEvents.push(trackData.concealmentEvents);
        this.insertedSamplesForDeceleration.push(trackData.insertedSamplesForDeceleration);
        this.removedSamplesForAcceleration.push(trackData.removedSamplesForAcceleration);
        this.silentConcealedSamples.push(trackData.silentConcealedSamples);
        this.totalAudioEnergy.push(trackData.totalAudioEnergy);
        this.totalSamplesDuration.push(trackData.totalSamplesDuration);
        this.totalSamplesReceived.push(trackData.totalSamplesReceived);
        this.jitterBufferFlushes.push(trackData.jitterBufferFlushes);
    };
    return WebRTCInboundAudioStreamTrackSeries;
}(TimestampSeries);
export var WebRTCInboundVideoStreamTrackData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCInboundVideoStreamTrackData, TimestampedData);
    var _super = _createSuper(WebRTCInboundVideoStreamTrackData);
    function WebRTCInboundVideoStreamTrackData(stats) {
        _classCallCheck(this, WebRTCInboundVideoStreamTrackData);
        var _this;
        _this = _super.call(this, stats);
        _this.jitterBufferDelay = stats.jitterBufferDelay;
        _this.jitterBufferEmittedCount = stats.jitterBufferEmittedCount;
        _this.frameHeight = stats.frameHeight;
        _this.frameWidth = stats.frameWidth;
        _this.framesDecoded = stats.framesDecoded;
        _this.framesDropped = stats.framesDropped;
        _this.framesReceived = stats.framesReceived;
        _this.freezeCount = stats.freezeCount;
        _this.pauseCount = stats.pauseCount;
        _this.totalFramesDuration = stats.totalFramesDuration;
        _this.totalFreezesDuration = stats.totalFreezesDuration;
        _this.totalPausesDuration = stats.totalPausesDuration;
        _this.sumOfSquaredFramesDuration = stats.sumOfSquaredFramesDuration;
        return _this;
    }
    return WebRTCInboundVideoStreamTrackData;
}(TimestampedData);
export var WebRTCInboundVideoStreamTrackSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCInboundVideoStreamTrackSeries, TimestampSeries);
    var _super = _createSuper(WebRTCInboundVideoStreamTrackSeries);
    function WebRTCInboundVideoStreamTrackSeries() {
        _classCallCheck(this, WebRTCInboundVideoStreamTrackSeries);
        var _this;
        _this = _super.call(this);
        _this.jitterBufferDelay = [];
        _this.jitterBufferEmittedCount = [];
        _this.frameHeight = [];
        _this.frameWidth = [];
        _this.framesDecoded = [];
        _this.framesDropped = [];
        _this.framesReceived = [];
        _this.freezeCount = [];
        _this.pauseCount = [];
        _this.totalFramesDuration = [];
        _this.totalFreezesDuration = [];
        _this.totalPausesDuration = [];
        _this.sumOfSquaredFramesDuration = [];
        return _this;
    }
    var _proto = WebRTCInboundVideoStreamTrackSeries.prototype;
    _proto.push = function push(trackData) {
        this.timestamps.push(trackData.timestamp);
        this.jitterBufferDelay.push(trackData.jitterBufferDelay);
        this.jitterBufferEmittedCount.push(trackData.jitterBufferEmittedCount);
        this.frameHeight.push(trackData.frameHeight);
        this.frameWidth.push(trackData.frameWidth);
        this.framesDecoded.push(trackData.framesDecoded);
        this.framesDropped.push(trackData.framesDropped);
        this.framesReceived.push(trackData.framesReceived);
        this.freezeCount.push(trackData.freezeCount);
        this.pauseCount.push(trackData.pauseCount);
        this.totalFramesDuration.push(trackData.totalFramesDuration);
        this.totalFreezesDuration.push(trackData.totalFreezesDuration);
        this.totalPausesDuration.push(trackData.totalPausesDuration);
        this.sumOfSquaredFramesDuration.push(trackData.sumOfSquaredFramesDuration);
    };
    return WebRTCInboundVideoStreamTrackSeries;
}(TimestampSeries);
export var WebRTCAudioSourceData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCAudioSourceData, TimestampedData);
    var _super = _createSuper(WebRTCAudioSourceData);
    function WebRTCAudioSourceData(stats) {
        _classCallCheck(this, WebRTCAudioSourceData);
        var _this;
        _this = _super.call(this, stats);
        _this.audioLevel = stats.audioLevel;
        _this.totalAudioEnergy = stats.totalAudioEnergy;
        _this.totalSamplesDuration = stats.totalSamplesDuration;
        return _this;
    }
    return WebRTCAudioSourceData;
}(TimestampedData);
export var WebRTCAudioSourceSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCAudioSourceSeries, TimestampSeries);
    var _super = _createSuper(WebRTCAudioSourceSeries);
    function WebRTCAudioSourceSeries() {
        _classCallCheck(this, WebRTCAudioSourceSeries);
        var _this;
        _this = _super.call(this);
        _this.audioLevel = [];
        _this.totalAudioEnergy = [];
        _this.totalSamplesDuration = [];
        return _this;
    }
    var _proto = WebRTCAudioSourceSeries.prototype;
    _proto.push = function push(sourceData) {
        this.timestamps.push(sourceData.timestamp);
        this.audioLevel.push(sourceData.audioLevel);
        this.totalAudioEnergy.push(sourceData.totalAudioEnergy);
        this.totalSamplesDuration.push(sourceData.totalSamplesDuration);
    };
    return WebRTCAudioSourceSeries;
}(TimestampSeries);
export var WebRTCVideoSourceData = /*#__PURE__*/ function(TimestampedData) {
    "use strict";
    _inherits(WebRTCVideoSourceData, TimestampedData);
    var _super = _createSuper(WebRTCVideoSourceData);
    function WebRTCVideoSourceData(stats) {
        _classCallCheck(this, WebRTCVideoSourceData);
        var _this;
        _this = _super.call(this, stats);
        _this.framesPerSecond = stats.framesPerSecond;
        return _this;
    }
    return WebRTCVideoSourceData;
}(TimestampedData);
export var WebRTCVideoSourceSeries = /*#__PURE__*/ function(TimestampSeries) {
    "use strict";
    _inherits(WebRTCVideoSourceSeries, TimestampSeries);
    var _super = _createSuper(WebRTCVideoSourceSeries);
    function WebRTCVideoSourceSeries() {
        _classCallCheck(this, WebRTCVideoSourceSeries);
        var _this;
        _this = _super.call(this);
        _this.framesPerSecond = [];
        return _this;
    }
    var _proto = WebRTCVideoSourceSeries.prototype;
    _proto.push = function push(sourceData) {
        this.timestamps.push(sourceData.timestamp);
        this.framesPerSecond.push(sourceData.framesPerSecond);
    };
    return WebRTCVideoSourceSeries;
}(TimestampSeries);
export var PublisherWebRTCMetricsUpdate = /*#__PURE__*/ function() {
    "use strict";
    function PublisherWebRTCMetricsUpdate() {
        _classCallCheck(this, PublisherWebRTCMetricsUpdate);
        this.streamStats = null;
        this.videoSSRC = 0;
        this.audioSSRC = 0;
        this.videoStreamTrackData = null;
        this.audioSourceData = null;
        this.videoSourceData = null;
        this.audioOutboundRtpData = null;
        this.videoOutboundRtpData = null;
        this.transportData = null;
    }
    var _proto = PublisherWebRTCMetricsUpdate.prototype;
    _proto.setAudioSSRC = function setAudioSSRC(ssrc) {
        this.audioSSRC = ssrc;
    };
    _proto.setVideoSSRC = function setVideoSSRC(ssrc) {
        this.videoSSRC = ssrc;
    };
    _proto.setAudioOutboundRtpStreamStats = function setAudioOutboundRtpStreamStats(stats) {
        this.audioOutboundRtpData = new WebRTCOutboundAudioRtpStreamData(stats);
    };
    _proto.setVideoOutboundRtpStreamStats = function setVideoOutboundRtpStreamStats(stats) {
        this.videoOutboundRtpData = new WebRTCOutboundVideoRtpStreamData(stats);
    };
    _proto.setTransportStats = function setTransportStats(stats) {
        this.transportData = new WebRTCTransportData(stats);
    };
    _proto.setAudioSourceStats = function setAudioSourceStats(stats) {
        this.audioSourceData = new WebRTCAudioSourceData(stats);
    };
    _proto.setVideoSourceStats = function setVideoSourceStats(stats) {
        this.videoSourceData = new WebRTCVideoSourceData(stats);
    };
    _proto.setVideoTrackStats = function setVideoTrackStats(stats) {
        this.videoStreamTrackData = new WebRTCMediaStreamTrackData(stats);
    };
    _proto.setStreamStats = function setStreamStats(stats) {
        this.streamStats = stats;
    };
    return PublisherWebRTCMetricsUpdate;
}();
export var SubscriberWebRTCMetricsUpdate = /*#__PURE__*/ function() {
    "use strict";
    function SubscriberWebRTCMetricsUpdate() {
        _classCallCheck(this, SubscriberWebRTCMetricsUpdate);
        this.streamStats = null;
        this.audioInboundRtpData = null;
        this.videoInboundRtpData = null;
        this.audioInboundTrackData = null;
        this.videoInboundTrackData = null;
        this.transportData = null;
    }
    var _proto = SubscriberWebRTCMetricsUpdate.prototype;
    _proto.setAudioInboundRtpStats = function setAudioInboundRtpStats(stats) {
        this.audioInboundRtpData = new WebRTCInboundAudioRtpStreamData(stats);
    };
    _proto.setVideoInboundRtpStats = function setVideoInboundRtpStats(stats) {
        this.videoInboundRtpData = new WebRTCInboundVideoRtpStreamData(stats);
    };
    _proto.setAudioInboundTrackStats = function setAudioInboundTrackStats(stats) {
        this.audioInboundTrackData = new WebRTCInboundAudioStreamTrackData(stats);
    };
    _proto.setVideoInboundTrackStats = function setVideoInboundTrackStats(stats) {
        this.videoInboundTrackData = new WebRTCInboundVideoStreamTrackData(stats);
    };
    _proto.setTransportStats = function setTransportStats(stats) {
        this.transportData = new WebRTCTransportData(stats);
    };
    _proto.setStreamStats = function setStreamStats(stats) {
        this.streamStats = stats;
    };
    return SubscriberWebRTCMetricsUpdate;
}();
